module.exports = __webpack_public_path__ + "static/media/HOW DO YOU ADD OR MAINTAIN SCHOOL COMMISSION.5968d71b.png";